import { useEffect, useState } from 'react'

import type { AgoraRTCClientWrapper } from '@core/agoraRTC/libs/AgoraRTCClientWrapper'

/**
 * Hooks that listens to Agora client wrapper connection state change and set it
 * to local state.
 */
export function useConnectionState(
  agoraClient: AgoraRTCClientWrapper | undefined,
) {
  const [connectionState, setConnectionState] = useState(
    agoraClient?.connectionState ?? 'DISCONNECTED',
  )

  useEffect(() => {
    if (!agoraClient) {
      setConnectionState('DISCONNECTED')
      return
    }
    return agoraClient.onConnectionStateChange((curr) => {
      setConnectionState(curr)
    })
  }, [agoraClient])

  return connectionState
}
